import OfferForm from './OfferForm';

const Offer = () => {
  return (
    <div id="offer" className="bg-[#9ebf91] py-[48px] md:py-[80px]">
      <div className="container">
        <div className="flex lg:flex-row flex-col gap-[48px] lg:gap-[76px] items-start lg:items-center">
          <h2 className="font-[700] text-[42px] md:text-[48px] leading-[48px] md:leading-[56px] uppercase mx-auto max-w-[360px] w-full text-center md:text-left">
            Ստանալ առաջարկ
          </h2>
          <div className="flex-1 w-full">
            <OfferForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;
